<template>
    <div class="animated fadeIn" id="faturamento-competencia">
        <div class="card card-default">
            <div class="card-header">
                <div class="card-header"><i class="icon-clock"></i> Plano de Atividades
 </div>
            </div>
            <div class="card-body">
                <!-- ALERTA DE DATAS -->
                <b-alert v-model="alertDatas" variant="danger" dismissible class="mb-3">
                    As duas datas devem estar preenchidas
                </b-alert>
                <div class="input-group mb-3 align-items-center" style="gap: 10px;">
                    <span class="input-group-text d-flex align-items-center justify-content-center" id="profissional"
                        style="width: 100px; height: 40px;">
                        Profissional
                    </span>
                    <!-- Dropdown multiselect -->
                    <b-dropdown :text="dropdownLabel" class="align-middle custom-dropdown"
                        toggle-class="custom-dropdown-input" no-close-on-click no-auto-close="outside">
                        <b-dropdown-item-button @click="selecionarTodosProfissionais" style="min-width: 250px;">
                            <i class="fa fa-check-square mr-2"></i> Selecionar todos
                        </b-dropdown-item-button>
                        <b-dropdown-item-button @click="limparProfissionaisSelecionados" style="min-width: 250px;">
                            <i class="fa fa-times mr-2"></i> Limpar seleção
                        </b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <div v-for="(prof, idx) in profissionais"
                            :key="`${checkboxRenderKey}-prof-${prof && prof.id ? prof.id : idx}`" class="px-3 py-1">
                            <b-form-checkbox v-model="selectedProfissionais" :value="prof">
                                {{ prof.nome }}
                            </b-form-checkbox>
                        </div>
                    </b-dropdown>
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Data Inicial
                    </span>
                    <date-picker input-class="form-control datepicker-custom" v-model="dataInicial" lang="pt-br"
                        format="DD/MM/YYYY" :placeholder="'Data inicial'" style="width: 160px; margin-right: 8px;"
                        @change="onChangeDataInicial" />
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Data Final
                    </span>
                    <date-picker input-class="form-control datepicker-custom" v-model="dataFinal" lang="pt-br"
                        format="DD/MM/YYYY" :placeholder="'Data final'" style="width: 160px; margin-right: 8px;"
                        :disabled-date="disableDataFinal" @change="onChangeDataFinal" />
                    <!-- Botão Filtrar -->
                    <button class="btn btn-primary" style="height: 40px;" @click="filtrar" :disabled="isLoading">
                        <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                        <span v-else><i class="icon-magnifier"></i> Filtrar</span>
                    </button>
                    <!-- Checkbox Inativo -->
                    <div class="form-check ml-3">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox-inativo"
                            v-model="filtrarInativo"
                        />
                        <label class="form-check-label" for="checkbox-inativo">
                            Inativo
                        </label>
                    </div>
                </div>
                <!-- Tabela de Prioridades dos Analistas -->
                <div v-if="prioridadesAnalistas.length > 0" class="mt-4">
                    <h5>Prioridades dos Analistas</h5>
                    <table class="table table-bordered table-striped table-sm tabela-prioridades text-center align-middle" style="table-layout: fixed;">
                        <thead>
                            <tr>
                                <th style="width: 60px; text-align: left;">Nome</th>
                                <th style="width: 300px; text-align: left;">Título</th>
                                <th style="width: 130px;">Label</th>
                                <th style="width: 70px;">Data de Entrega</th>
                                <th style="width: 70px;">Tipo de Demanda</th>
                                <th style="width: 200px;">Ação</th>
                                <th style="width: 60px;">Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, idx) in prioridadesAnalistas"
                                :key="`prioridade-${idx}`"
                                :class="{ 'linha-inativa': (item.status || '').toLowerCase() === 'inativo' }"
                            >
                                <td class="text-left">
                                    <span
                                        class="nome-truncado"
                                        :title="item.nome"
                                    >
                                        {{ item.nome }}
                                    </span>
                                </td>
                                <td class="text-left">
                                    <span
                                        class="titulo-truncado"
                                        :title="item.title"
                                    >
                                        {{ item.title }}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        class="label-truncado"
                                        :title="item.label"
                                    >
                                        {{ item.label }}
                                    </span>
                                </td>
                                <td>{{ item.due_date }}</td>
                                <td>
                                    <span
                                        class="tipo-demanda-badge"
                                        :class="getTipoDemandaClass(item.tipo_demanda)"
                                    >
                                        {{ item.tipo_demanda }}
                                    </span>
                                </td>
                                <td>
                                    <multiselect
                                        v-model="item.etapasSelecionadas"
                                        :options="getEtapasOptions(item.tipo_demanda)"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :preserve-search="true"
                                        placeholder="Selecione "
                                        label="label"
                                        track-by="value"
                                        style="min-width: 260px; max-width: 180px;"
                                        @input="postAtualizarEtapa(item)"
                                        :show-no-results="false"
                                        :show-labels="false"
                                        :custom-label="option => option.label"
                                        :append-to-body="true"
                                    >
                                        <template #option="{ option }">
                                            <span :title="option.label" class="multiselect-option-wide">{{ option.label }}</span>
                                        </template>
                                        <template #tag="{ option, remove }">
                                            <span class="multiselect-tag" :title="option.label">
                                                {{ option.label }}
                                                <span class="multiselect-tag-remove" @click.stop="remove(option)">×</span>
                                            </span>
                                        </template>
                                        <template #noResult></template>
                                        <template #noOptions></template>
                                        <template #caret></template>
                                        <template #afterList></template>
                                    </multiselect>
                                </td>
                                <td>
                                    <a :href="item.url" target="_blank">Abrir Issue</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Uteis from "@/mixins/utils.js";
import MetaSelect from "meta-select";
import DatePicker from "vue2-datepicker";
import Multiselect from 'vue-multiselect';

export default {
    name: 'PrioridadeAnalistasIndex',
    mixins: [Uteis],
    components: {
        MetaSelect,
        DatePicker,
        Multiselect,
    },
    data() {
        return {
            selectProfissionais: 0,
            profissionais: [],
            selectedProfissionais: [],
            checkboxRenderKey: 0,
            dataInicial: null,
            dataFinal: null,
            erroDatas: "",
            prioridadesAnalistas: [],
            alertDatas: false,
            isLoading: false,
            filtrarInativo: false,
        }
    },
    computed: {
        dropdownLabel() {
            const total = this.selectedProfissionais.length;
            return total === 0
                ? "Selecionar profissionais"
                : `${total} profissional${total > 1 ? "is" : ""} selecionado${total > 1 ? "s" : ""}`;
        }
    },
    async mounted() {
        await this.getProfissionais();
    },
    methods: {
        async getProfissionais() {
            const data = 947;
            try {
                const response = await this.$http.get("/gestao-demandas/profissionais", {
                    params: { idUsuarioGitlab: data }
                });
                this.profissionais = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error('Erro ao buscar profissionais:', error);
                this.$toasted.error('Erro ao buscar profissionais.');
                this.profissionais = [];
            }
        },
        selecionarTodosProfissionais() {
            this.selectedProfissionais = this.profissionais.slice();
            this.checkboxRenderKey++;
        },
        limparProfissionaisSelecionados() {
            this.selectedProfissionais = [];
            this.checkboxRenderKey++;
        },
        onChangeDataInicial(val) {
            if (this.dataFinal && val && new Date(this.dataFinal) < new Date(val)) {
                this.erroDatas = "A data final não pode ser menor que a data inicial.";
                this.dataFinal = null;
                if (typeof this.notificar === 'function') {
                    this.notificar(this.erroDatas, 'prioridade-analistas');
                } else if (this.$toasted) {
                    this.$toasted.error(this.erroDatas);
                }
            } else {
                this.erroDatas = "";
            }
        },
        onChangeDataFinal(val) {
            if (this.dataInicial && val && new Date(val) < new Date(this.dataInicial)) {
                this.erroDatas = "A data final não pode ser menor que a data inicial.";
                this.dataFinal = null;
                if (typeof this.notificar === 'function') {
                    this.notificar(this.erroDatas, 'prioridade-analistas');
                } else if (this.$toasted) {
                    this.$toasted.error(this.erroDatas);
                }
            } else {
                this.erroDatas = "";
            }
        },
        disableDataFinal(date) {
            if (!this.dataInicial) return false;
            return date < new Date(this.dataInicial);
        },
        async filtrar() {
            // Validação das datas
            if (
                (this.dataInicial && !this.dataFinal) ||
                (!this.dataInicial && this.dataFinal)
            ) {
                this.alertDatas = false; // força reset para garantir reatividade
                this.$nextTick(() => {
                    this.alertDatas = true;
                });
                return;
            }
            this.isLoading = true;
            const formatDate = (date) => {
                if (!date) return null;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };
            const dataInicialFormatada = formatDate(this.dataInicial);
            const dataFinalFormatada = formatDate(this.dataFinal);
            const payload = {
                dataInicial: dataInicialFormatada,
                dataFinal: dataFinalFormatada,
                idUsuarioGitlab: this.selectedProfissionais.map(prof => prof.usuario_gitlab_id),
                status: this.filtrarInativo ? 'Inativo' : 'Ativo'
            };
            try {
                const response = await this.$http.get(
                    "/gestao-demandas/prioridades-analistas",
                    {
                        headers: { "Content-Type": "application/json" },
                        params: payload
                    }
                );
                // Salva os dados para exibir na tabela
                console.log('Prioridades dos analistas:', response.data.prioridades);
                this.prioridadesAnalistas = Array.isArray(response.data.prioridades) ? response.data.prioridades : [];
                // Preenche etapasSelecionadas a partir de tipo_opcoes, se existir
                this.prioridadesAnalistas.forEach(item => {
                    // Garante que tipo_opcoes seja array
                    let opcoes = [];
                    if (Array.isArray(item.tipo_opcoes)) {
                        opcoes = item.tipo_opcoes;
                    } else if (typeof item.tipo_opcoes === 'string' && item.tipo_opcoes.trim() !== '') {
                        opcoes = item.tipo_opcoes.includes(',')
                            ? item.tipo_opcoes.split(',').map(s => s.trim())
                            : [item.tipo_opcoes.trim()];
                    }
                    // Busca as opções válidas para o tipo de demanda
                    const validOptions = this.getEtapasOptions(item.tipo_demanda);
                    // Seleciona o objeto de opção correspondente (apenas um)
                    item.etapasSelecionadas = validOptions.find(opt => opcoes.includes(opt.value)) || null;
                });
            } catch (error) {
                console.error('Erro ao buscar prioridades dos analistas:', error);
                this.$toasted.error('Erro ao buscar prioridades dos analistas.');
                this.prioridadesAnalistas = [];
            } finally {
                this.isLoading = false;
            }
        },
        getTipoDemandaClass(tipo) {
            switch ((tipo || '').toLowerCase()) {
                case 'investigativa':
                    return 'tipo-investigativa';
                case 'garantia':
                    return 'tipo-garantia';
                case 'incidente':
                    return 'tipo-incidente';
                case 'melhoria':
                    return 'tipo-melhoria';
                default:
                    return '';
            }
        },
        getEtapasOptions(tipo) {
            const tipoLower = (tipo || '').toLowerCase();
            if (tipoLower === 'melhoria') {
                return [
                    { label: 'Iniciar especificação funcional', value: 'Iniciar especificação funcional' },
                    { label: 'Evoluir especificação funcional', value: 'Evoluir especificação funcional' },
                    { label: 'Concluir especificação funcional', value: 'Concluir especificação funcional' },
                    { label: 'Apoiar qualificação', value: 'Apoiar qualificação' },
                    { label: 'Acompanhar aprovações', value: 'Acompanhar aprovações' },
                    { label: 'Apoiar desenvolvimento', value: 'Apoiar desenvolvimento' },
                    { label: 'Realizar testes/homologação', value: 'Realizar testes/homologação' },
                    { label: 'Realizar validação com a área', value: 'Realizar validação com a área' },
                    { label: 'Entregar em Produção', value: 'Entregar em Produção' },
                ];
            }
            // Investigativa, Incidente, Garantia
            return [
                { label: 'Realizar análise', value: 'Realizar análise' },
                { label: 'Realizar análise junto à FSW', value: 'Realizar análise junto à FSW' },
                { label: 'Realizar testes/homologação', value: 'Realizar testes/homologação' },
                { label: 'Realizar validação com a área', value: 'Realizar validação com a área' },
                { label: 'Entregar em Produção', value: 'Entregar em Produção' },
            ];
        },
        postAtualizarEtapa(item) {
            const tipo_opcao = item.etapasSelecionadas ? item.etapasSelecionadas.value : '';
            this.$http.get('/gestao-demandas/atualiza-opcao', {
                params: {
                    id: item.id,
                    tipo_opcao
                }
            }).then(() => {
                // Recarrega a tabela após atualizar
                this.filtrar();
            }).catch(() => {
                this.$toasted && this.$toasted.error('Erro ao atualizar etapa.');
            });
        }
    },
    watch: {
        prioridadesAnalistas: {
            handler(novos) {
                if (Array.isArray(novos)) {
                    novos.forEach(item => {
                        if (!item.etapasSelecionadas) {
                            this.$set(item, 'etapasSelecionadas', null);
                        }
                    });
                }
            },
            immediate: true,
            deep: true
        }
    },
}
</script>

<style>
.input-group-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-size: 14px;
    height: 40px;
}

/* DatePicker customizado para altura igual ao span */
.datepicker-custom {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    font-size: 14px;
}

/* Customização do dropdown */
.custom-dropdown .dropdown-toggle {
    display: inline-block;
    /* garante alinhamento */
    vertical-align: middle;
    background-color: transparent !important;
    border: 1px solid #dde2e7 !important;
    color: #6c757d !important;
    border-radius: 4px;
    min-width: 280px;
    width: 280px;
    height: 40px;
    line-height: 1.5;
}


.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
    box-shadow: none !important;
}

.custom-dropdown.show .dropdown-toggle {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
}

.custom-dropdown .dropdown-menu {
    border: 1px solid #6c757d;
    border-radius: 4px;
    min-width: 280px;
    width: 280px;
}

.custom-dropdown .dropdown-item {
    min-width: 250px;
    width: 250px;
}

.tipo-demanda-badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 12px;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    /* min-width removido para permitir coluna menor */
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    vertical-align: middle;
    /* Centraliza verticalmente na célula */
    margin-top: 0;
    margin-bottom: 0;
}
.tipo-investigativa {
    background-color: #007bff;
}
.tipo-garantia {
    background-color: #ffc107;
    color: #212529;
}
.tipo-incidente {
    background-color: #dc3545;
}
.tipo-melhoria {
    background-color: #28a745;
}
.linha-inativa {
    background-color: #ffe5e5 !important;
}
.titulo-truncado {
    display: inline-block;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
}
.label-truncado {
    display: inline-block;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    text-align: center;
}
.multiselect-tag {
    display: inline-block;
    background: #f0f0f0;
    color: #333;
    border-radius: 3px;
    padding: 2px 6px;
    margin-right: 2px;
    font-size: 12px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
}
.multiselect-tag-remove {
    margin-left: 4px;
    cursor: pointer;
    color: #888;
}
.multiselect-tag-remove:hover {
    color: #dc3545;
}
.table th,
.table td {
    vertical-align: middle !important;
    text-align: center;
}
.table th.text-left,
.table td.text-left {
    text-align: left !important;
}
.multiselect-option-wide {
    min-width: 220px;
    max-width: 320px;
    display: inline-block;
    white-space: normal;
    word-break: break-word;
}
.multiselect__content-wrapper {
    min-width: 220px !important;
    max-width: 320px !important;
}
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.nome-truncado {
    display: inline-block;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
}
</style>
